import { api } from 'api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useChangeUserIdentification = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload) => api.identifications.changeIdentification(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при изменении идентификации',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
